// extracted by mini-css-extract-plugin
export default {"wrapper":"BackButton_wrapper__GErH5","cookieAccepted":"BackButton_cookieAccepted__xgIeH","back":"BackButton_back__dW4qg"};